module.exports = {
    important: true,
    theme: {
        screens: {
            xsm: '360px',
            sm: '640px',
            md: '768px',
            lg: '1200px',
            xl: '1600px',
            xxl: '2560px',
        },
        extend: {
            fontSize: {
                'xxs': '0.5rem',
                'sm': '0.875rem',
                'base': '0.935rem',
                '2xl': '1.4rem',
                '2xs': '0.625rem',
                '2p5xl': '1.6875rem',
                '0.75': '0.75rem',
            },
            fontFamily: {
                'gr-book': 'Gotham Rounded Book',
                'gr-light': 'Gotham Rounded Light',
                'gr-medium': 'Gotham Rounded Medium',
                'fr-book': 'Futura Book',
                'tomatoes': 'Tomatoes',
            },
            margin: {
                init: 'initial',
            },
            spacing: {
                'px': '1px',
                '2px': '2px',
                '26': '6.5rem',
                '28': '7rem',
                '10/0': '10%',
                '12/0': '12%',
                '15/0': '15%',
                '20/0': '20%',
                '30/0': '30%',
                '35/0': '35%',
                '40/0': '40%',
                '45/0': '45%',
                '48/0': '48%',
                '49/0': '49%',
                '50/0': '50%',
                '51/0': '51%',
                '52/0': '52%',
                '55/0': '55%',
                '60/0': '60%',
            },
            padding: {
                '1.5em': '0.375em',
                '7': '1.75rem',
                '9': '2.25rem',
                '11': '2.75rem',
                '13': '3.25rem',
                '14': '3.5rem',
                '18': '4.5rem',
                '22': '5.5rem',
                '50': '12.5rem',
                '52': '13rem',
                '54': '13.5rem',
                '16-9': '56.25%', // 16 by 9 aspect ratio
            },
            margin: {
                '7': '1.75rem',
                '9': '2.25rem',
                '11': '2.75rem',
                '13': '3.25rem',
                '14': '3.5rem',
                '18': '4.5rem',
                '22': '5.5rem',
                '50': '12.5rem',
                '52': '13rem',
                '54': '13.5rem',
            },
            width: {
                '1.6': '0.4rem',
                '7': '1.75rem',
                '9': '2.25rem',
                '11': '2.75rem',
                '14': '3.5rem',
                '18': '4.5rem',
                '20': '5rem',
                '21': '5.25rem',
                '22': '5.5rem',
                '23': '5.75rem',
                '26': '6.5rem',
                '28': '7rem',
                '30': '7.5rem',
                '34': '8.5rem',
                '36': '9rem',
                '38': '9.5rem',
                '41': '10rem',
                '42': '10.5rem',
                '44': '11rem',
                '50': '12.5rem',
                '55': '13.75rem',
                '65': '16.25rem',
                '72': '18rem',
                '80': '20rem',
                '88': '22rem',
                '96': '24rem',
                '128': '32rem',
            },
            height: {
                '1px': '1px',
                '1/4': '25%',
                '1/2': '50%',
                '3/4': '75%',
                '60/0': '60%',
                '70/0': '70%',
                '80/0': '80%',
                '90/0': '90%',
                7: '1.75rem',
                9: '2.25rem',
                11: '2.75rem',
                '12.5': '3.125rem',
                14: '3.5rem',
                15: '3.75rem',
                16: '4rem',
                17: '4.25rem',
                18: '4.5rem',
                20: '5rem',
                22: '5.5rem',
                36: '9rem',
                48: '12rem',
                56: '14rem',
                64: '16rem',
                72: '18rem',
                80: '20rem',
                88: '22rem',
                96: '24rem',
                104: '28rem',
                120: '32rem',
                128: '36rem',
                136: '40rem',
                144: '44rem',
                152: '48rem',
                156: '52rem',
                160: '56rem',
                168: '60rem',
                640: '640px',
            },
            maxHeight: {
                '0': '0',
                '1/4': '25%',
                '1/2': '50%',
                '3/4': '75%',
                'full': '100%',
                '2vh': '200vh',
                '5vh': '500vh',
                '3/4-screen': '75vh',
            },
            maxWidth: {
                '1/4': '25%',
                '1/3': '33.33%',
                '1/2': '50%',
                '2/5': '40%',
                '3/4': '75%',
            },
            minHeight: {
                '0': '0',
                '1/4': '25%',
                '1/2': '50%',
                '3/4': '75%',
                '14': '3.5rem',
                '16': '4rem',
                '18': '4.5rem',
                '20': '5rem',
                '22': '5.5rem',
                '26': '6.5rem',
                '28': '7rem',
                '32': '8rem',
                '36': '9rem',
                '40': '10rem',
                '48': '12rem',
                'full': '100%',
                '6xs': '2rem',
                '5xs': '4rem',
                '4xs': '8rem',
                '3xs': '12rem',
                '2xs': '16rem',
                'xs': '20rem',
                'sm': '24rem',
                'md': '28rem',
                'lg': '32rem',
                'xl': '36rem',
                '2xl': '42rem',
                '3xl': '48rem',
                '4xl': '56rem',
                '5xl': '64rem',
                '6xl': '72rem',
            },
            lineHeight: {
                tighter: '1.15',
            },
            minWidth: {
                '0': '0',
                '1/4': '25%',
                '1/3': '33.33%',
                '1/2': '50%',
                '3/4': '75%',
                '14': '3.5rem',
                '16': '4rem',
                '18': '4.5rem',
                '20': '5rem',
                '22': '5.5rem',
                '26': '6.5rem',
                '28': '7rem',
                '32': '8rem',
                '36': '9rem',
                'full': '100%',
                '5xs': '4rem',
                '4xs': '8rem',
                '3xs': '12rem',
                '2xs': '16rem',
                'xs': '20rem',
                'sm': '24rem',
                'md': '28rem',
                'lg': '32rem',
                'xl': '36rem',
                '2xl': '42rem',
                '3xl': '48rem',
                '4xl': '56rem',
                '5xl': '64rem',
                '6xl': '72rem',
            },
            colors: {
                'brown': '#a48f7f',
                'brown': {
                    lighter: '#bea999',
                    default: '#a48f7f',
                    dark: '#8b7666',
                },
                'black': '#000',
                'white': '#fff',
                'ash': '#929da1',
                'lightash': '#eeeeee',
                'ashblue': '#93a6b1',
                'ashgray': '#666c70',
                'ashgreen': '#aebcb8',
                'asphalt': '#4c4b4a',
                'cement': '#f2edeb',
                'charcoal': '#373435',
                'clay': '#9d908d',
                'coolGray': '#363b48',
                'cotton': '#ffffff',
                'dustygreen': '#afc2bb',
                'limestone': '#f4eae0',
                'metal': '#a4a3a2',
                'olive': '#707d6f',
                'onyx': '#231f20',
                'stone': '#393b44',
                'tan': '#a78e80',
                'blacksemitransparent': 'rgba(0, 0, 0, 0.4)',
                'slate': '#626060',
                'slategray': '#373b48',
                'red': '#FF0000',
                'error-red': '#ba002c',
                'boon-gray': {
                    default: '#f8f5f3',
                    privacy: '#f2f2f2',
                },
                'boon-brown': {
                    default: '#a39c92',
                    semidark: '#a49c92',
                    dark: '#a38f81',
                },
                'login-brown': '#9e8d7e',
                'boon-brown-beige': '#f4eae0',
                'boon-ash-gray': '#f5f4f3',
                'boon-ash-brown': '#c7bbb4',
                'boon-black': {
                    default: '#373b48',
                    dark: '#2d2d2d',
                },
                'boon-beige': '#f8f4f3',
                'mini-boon': '#a68e80',
                'full-boon': '#000',
                'super-boon': '#90a5b0',
                'white-50': 'rgba(255, 255, 255, 0.5)',
                'white-75': 'rgba(255, 255, 255, 0.75)',
                'white-80': 'rgba(255, 255, 255, 0.80)',
                'white-85': 'rgba(255, 255, 255, 0.85)',
                'white-90': 'rgba(255, 255, 255, 0.90)',
                'white-95': 'rgba(255, 255, 255, 0.95)',
            },
            opacity: {
                '10': '.1',
                '20': '.2',
                '30': '.3',
                '40': '.4',
                '50': '.5',
                '60': '.6',
                '70': '.7',
                '80': '.8',
                '90': '.9',
                '95': '.95',
                '97': '.97',
                '98': '.98',
            },
            zIndex: {
                '-10': '-10',
                '-20': '-20',
            },
            boxShadow: {
                'outline-sm': '0 0 0 3px rgba(0, 0, 0, 0.15)',
                'bottom-left': '-12px 0 15px 3px rgba(0, 0, 0, 0.15) ',
            },
            textShadow: {
                sm: '0 1px 2px rgba(0, 0, 0, 0.5)',
                default: '0 2px 5px rgba(0, 0, 0, 0.5)',
                lg: '0 2px 10px rgba(0, 0, 0, 0.5)',
                xl: '0 4px 10px rgba(0, 0, 0, 0.75)',
            },
            textShadow: {
                sm: '0 1px 2px rgba(0, 0, 0, 0.5)',
                default: '0 2px 5px rgba(0, 0, 0, 0.5)',
                lg: '0 2px 10px rgba(0, 0, 0, 0.5)',
            },
            letterSpacing: {
                '1px': '1px',
            },
            borderRadius: {
                'xl': '0.75rem',
                '2xl': '1rem',
                '3xl': '1.5rem',
                '4xl': '2rem',
            },
        },
        inset: {
            '-4': '-4px',
            '-8': '-8px',
            '-10': '-10px',
            '-12': '-12px',
            '-16': '-16px',
            '-20': '-20px',
            '-24': '-24px',
            '-28': '-28px',
            '-32': '-32px',
            '-36': '-36px',
            '-40': '-40px',
            '-48': '-48px',
            '-60': '-60px',
            '-72': '-72px',
            '-1-r': '-0.25rem',
            '-2-r': '-0.5rem',
            '-3-r': '-0.75rem',
            '-6-r': '-1.5rem',
            '-8-r': '-2rem',
            '-12-r': '-3rem',
            '-14-r': '-3.5rem',
            '-16-r': '-4rem',
            '-18-r': '-4.5rem',
            '-20-r': '-5rem',
            '-22-r': '-5.5rem',
            '-24-r': '-6rem',
            '-28-r': '-7rem',
            '-32-r': '-8rem',
            'auto': 'auto',
            '0': 0,
            '4': '4px',
            '8': '8px',
            '10': '10px',
            '12': '12px',
            '16': '16px',
            '20': '20px',
            '24': '24px',
            '28': '28px',
            '32': '32px',
            '36': '36px',
            '40': '40px',
            '48': '48px',
            '60': '60px',
            '72': '72px',
            '1/2': '50%',
            '1-r': '0.25rem',
            '2-r': '0.5rem',
            '3-r': '0.75rem',
            '6-r': '1.5rem',
            '8-r': '2rem',
            '12-r': '3rem',
            '14-r': '3.5rem',
            '16-r': '4rem',
            '18-r': '4.5rem',
            '20-r': '5rem',
            '22r': '5.5rem',
            '24-r': '6rem',
            '28-r': '7rem',
            '32-r': '8rem',
        },
    },
    variants: {
        padding: ['responsive', 'first', 'last'],
        margin: ['responsive', 'first', 'last'],
        textColor: ['responsive', 'hover', 'group-hover', 'focus', 'active', 'odd', 'even'],
        backgroundColor: ['responsive', 'hover', 'group-hover', 'focus', 'active', 'odd', 'even'],
        extend: {
            minWidth: ['responsive'],
            whitespace: ['responsive'],
        }
    },
    corePlugins: {
        minWidth: true,
        whitespace: true,
    },
    plugins: [require('tailwindcss-typography')({})],
    purge: {
        content: ['./src/**/*.tsx', './config/*.ts'],

        options: {
            whitelist: ['min-w-50', 'whitespace-nowrap', 'md:inline', 'hidden', 'md:block', 'react-tag-input'],
        },
    },
};
